/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Row, Col, Button, Form, Input, Select, message } from "antd";
import pluse from "../../../../assests/images/childpackagePluseIcon.svg";
import crosImgForChildBagagge from "../../../../assests/images/onbording/delete-box.svg";
import { InfoCircleTwoTone } from "@ant-design/icons";

import { useLocation } from "react-router";
import axios from "axios";
import { APIs } from "../../../../utils/worker";
import {
  checkAlphabets,
  checkAlphaAndComma,
  checkNumbervalue,
  checkSpecialCharacter,
  checkSpace,
} from "../../../../utils";

function DeliveryDynamicInput({
  form,
  setFormValues,
  formValues,
  screen,
  SubmitDisable,
}) {
  const history = useLocation();
  const [apiError, setApiError] = useState({});
  const [dynamicInput, setDynamicInput] = useState({});
  console.log(dynamicInput);
  // console.log(history?.state);
  // useEffect(() => {
  //   form.setFieldValue("CPPin", history?.state?.premiseDto?.pincode);
  //   form.setFieldValue("CPPin" + 0, history?.state?.premiseDetails?.pincode);
  //   // handleChangeSearch(history?.state?.premiseDetails?.pincode?.toString(), 0);
  // }, [screen]);

  let addFormFields = () => {
    let randomString = Math.random().toString(36).slice(2);
    setFormValues([
      ...formValues,
      { id: randomString, pinCode: "", areaName: [], disabledAreaName: [] },
    ]);
  };

  let removeFormFields = (id) => {
    form.setFieldValue("Areaname" + id, null);
    form.setFieldValue("CPPin" + id, null);

    let newFormValues = [...formValues];

    newFormValues.splice(
      newFormValues.findIndex(function (i) {
        return i.id === id;
      }),
      1
    );

    setFormValues(newFormValues);
  };

  const onPincodeSender = async (values, name) => {
    if (values.target.value.length > 5) {
      // setLoading(true);

      try {
        let response = await fetch(
          `https://api.postalpincode.in/pincode/${values.target.value}`
        );
        let res = await response.json();

        if (res[0].Status == "Error") {
          message.error(`${values.target.value} is invalid Pincode`);
          form.setFieldsValue({
            ["Areaname" + name]: null,
            ["service" + name]: null,
          });
          form.setFields([
            {
              name: ["CPPin" + name], // Adjust the field name as needed
              errors: ["Invalid pincode"],
            },
          ]);
          setDynamicInput({
            ...dynamicInput,
            [name]: true,
          });
        } else {
          setApiError({
            validateStatus: "success",
            errorMsg: null,
          });
          setDynamicInput({
            ...dynamicInput,
            [name]: false,
          });
        }
      } catch (error) {
        console.log(error);
        // setLoading(false);
      }
    } else {
      form.setFieldsValue({
        City: null,
        StateName: null,
      });
    }
    checkCondition();
  };

  function checkCondition() {
    const errors = form.getFieldsError();
    console.log(errors);

    let res = errors.some((item) => item.errors && item.errors.length > 0);
    console.log(res);
    SubmitDisable(res);
  }

  const mainPincode = async (values, name) => {
    if (values.target.value.length > 5) {
      // setLoading(true);

      try {
        let response = await fetch(
          `https://api.postalpincode.in/pincode/${values.target.value}`
        );
        let res = await response.json();

        if (res[0].Status == "Error") {
          setApiError({
            validateStatus: "error",
            errorMsg: "Invalid Pincode",
          });
          message.error(`${values.target.value} is invalid Pincode`);
        } else {
          setApiError({
            validateStatus: "success",
            errorMsg: null,
          });
        }
      } catch (error) {
        console.log(error);
        // setLoading(false);
      }
    } else {
      form.setFieldsValue({
        City: null,
        StateName: null,
      });
    }
  };

  const onClickOption = (e, v, id) => {
    let gotValues = formValues;
    let index = gotValues.findIndex((item) => item.id === id);

    gotValues[index] = {
      ...gotValues[index],
      disabledAreaName: [...gotValues[index].disabledAreaName, v.children],
    };
    setFormValues([...gotValues]);
    let nonServiceArea = form.getFieldValue("nonServiceableArea" + id);
    form.setFieldValue("nonServiceableArea" + id, [
      ...nonServiceArea,
      v.children,
    ]);
  };

  const onClickNonservice = (e, v, id) => {
    let gotValues = formValues;
    let index = gotValues.findIndex((item) => item.id === id);
    let areaNames = gotValues[index].areaName;
    let actualValue = areaNames.find((item) => item.label === v.value);
    let newvalues = gotValues[index].disabledAreaName.filter(
      (item) => item !== v.children
    );
    gotValues[index] = {
      ...gotValues[index],
      areaName: [...gotValues[index].areaName, actualValue],
      disabledAreaName: [...newvalues],
    };
    setFormValues([...gotValues]);
    let seriveceArea = form.getFieldValue("Areaname" + id);
    form.setFieldValue("Areaname" + id, [...seriveceArea, actualValue]);
  };

  const onChangeHandler = (e, v, id) => {
    let gotValues = formValues;
    let index = formValues.findIndex((x) => x.id === id);
    let newareas = gotValues[index].disabledAreaName.filter(
      (xy) => xy !== v[v.length - 1].children
    );
    if (gotValues[index].disabledAreaName.includes(v[v.length - 1].children)) {
      gotValues[index] = {
        ...gotValues[index],
        disabledAreaName: [...newareas],
      };
      setFormValues([...gotValues]);
      form.setFieldValue("nonServiceableArea" + id, [...newareas]);
    }
  };

  return (
    <div>
      <Row gutter={40} className="global-form-row booking-details-container">
        <Col lg={7} className="form-inputs" style={{ marginTop: "0" }}>
          <Form.Item
            name="CPPin"
            label={"CP PIN code"}
            rules={[
              {
                required: true,
                message: "Please enter pincode",
              },
            ]}
            onKeyPress={(event) => {
              if (
                checkNumbervalue(event) ||
                checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
            validateStatus={apiError?.validateStatus}
            help={apiError?.errorMsg}
          >
            <Input
              placeholder="Enter CP pincode"
              type="text"
              maxLength={6}
              disabled={true}
              onChange={(e) => mainPincode(e)}
            />
          </Form.Item>
        </Col>
      </Row>

      {formValues.map((element, index) => (
        <div key={index} className="border-box">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              padding: "10px",
            }}
          >
            <div>
              <Button
                type="text"
                style={{
                  background: "none",
                  paddingRight: "20px",
                  paddingTop: "10px",

                  visibility: index === 0 ? "hidden" : "show",
                }}
              >
                <img
                  src={crosImgForChildBagagge}
                  className="delete-child-input-button"
                  onClick={() => {
                    removeFormFields(element.id);
                  }}
                />
              </Button>
            </div>
          </div>
          <Row
            gutter={40}
            className="global-form-row booking-details-container "
          >
            <Col lg={6} xs={24} style={{ marginTop: "0" }}>
              <Form.Item
                name={"CPPin" + element.id}
                label={"Delivery PIN code"}
                rules={[
                  {
                    required: true,
                    message: "Please Delivery Pincode",
                  },
                  () => ({
                    validator(rule, value = "") {
                      if (value.length > 0 && value.length < 6) {
                        return Promise.reject("Pincode should be 6 digits");
                      } else {
                        return Promise.resolve();
                      }
                    },

                    validateTrigger: "onSubmit",
                  }),
                ]}
                onKeyPress={(event) => {
                  if (
                    checkNumbervalue(event) ||
                    checkSpecialCharacter(event) ||
                    checkSpace(event)
                  ) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  placeholder="Enter CP pincode"
                  type="text"
                  maxLength={6}
                  // onChange={(e) => onPincodeSender(e, element.id)}

                  // onChange={(e) =>
                  //   handleChangeSearch(e.target.value, element.id)
                  // }
                />
              </Form.Item>
            </Col>
            <Col lg={6} xs={24}>
              <Form.Item name={"service" + element.id} label="Service">
                <Select
                  placeholder="Select Service"
                  options={[
                    {
                      value: "Regular",
                      label: "Regular",
                    },
                    {
                      value: "Regular & E-commerce",
                      label: "Regular & E-commerce",
                    },
                    {
                      value: "ODA1",
                      label: "ODA1",
                    },
                    {
                      value: "ODA2",
                      label: "ODA2",
                    },
                  ]}
                ></Select>
              </Form.Item>
            </Col>
            <Col lg={9} xs={24}>
              <Form.Item
                style={{ marginTop: "0" }}
                label="Serviceable area"
                className="serviceable-area"
                name={"Areaname" + element.id}
                extra={
                  <spna>
                    <InfoCircleTwoTone /> Add the areas in comma separated
                    values. Ex: Area 1, Area 2
                  </spna>
                }
                rules={[
                  {
                    required: true,
                    message: "Please select an option",
                  },
                ]}
                onKeyPress={(event) => {
                  if (checkAlphaAndComma(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  placeholder="Enter CP"
                  type="text"
                  onChange={() => checkCondition()}
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
      ))}
      <div className="delevery-pincode">
        <div className="child-baggage-modal-inputList-button">
          <Button
            style={{
              background: "none",
              border: " 1px solid #2E77D0",
              color: "#2E77D0",
              width: "auto",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderRadius: "5px",
              fontWeight: "700",
            }}
            type="dashed"
            onClick={() => addFormFields()}
          >
            <img src={pluse} style={{ margin: "5px" }} /> ADD DELIVERY PINCODE
          </Button>
        </div>
      </div>
    </div>
  );
}

export default DeliveryDynamicInput;
